import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';
import {TwoPaneModal} from 'shells/modal/two-pane-modal';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import {getServiceUrl} from '../../../external-meetings/helpers';
import {ConnectButton} from '../../../external-meetings/onboarding/connect-button';

import {appHistory} from '../../../../history';

import styles from './onboarding-module.module.css';

const MEETING_TYPES = ['ZOOM', 'GOOGLE_MEET', 'MICROSOFT_TEAMS'];

type Props = {
    onClose: () => void;
};

export function ConnectMeetingModal(props: Props) {
    return (
        <TwoPaneModal
            // @ts-expect-error
            isOpen={true}
            rightSection={
                <div>
                    <OnboardingBody title='Sign in to connect your meetings'>
                        <div className='my-16 flex flex-dir-col gap-16'>
                            {MEETING_TYPES.map((serviceType) => (
                                <ConnectButton
                                    key={serviceType}
                                    isConnected={false}
                                    onConnectClick={() => {
                                        appHistory.push({
                                            pathname: `${getServiceUrl(
                                                // @ts-expect-error
                                                serviceType
                                            )}/unlogged-meetings`,
                                            state: {openOnboardingModal: true},
                                        });
                                    }}
                                    // @ts-expect-error
                                    serviceType={serviceType}
                                />
                            ))}
                        </div>
                    </OnboardingBody>
                </div>
            }
            leftSection={
                <div className={styles['connect-meeting-modal-container']}>
                    <Illustration
                        src='trial-onboarding/trial-onboarding-meeting-integrations'
                        width={280}
                    />
                </div>
            }
            onClose={props.onClose}
        />
    );
}
